module.exports = __webpack_public_path__ + "media/documents/future-cd6ef85dccde2e6bdf9866c6a1a519a3.pdf";